






































































import Component from "vue-class-component";
import ImagePreview from "@/components/ImagePreview.vue";
import BasicComponent from "@/global/BasicComponent";
import NewsletterDialog from "@/components/NewsletterDialog.vue";
import {ImageCollectionDto, ImageDto, ImageOrientationDto} from "@swagger";
import VirtualScroll from "@/components/VirtualScroll.vue";
//import Masonry from "masonry-layout";

@Component({
  components: {VirtualScroll, NewsletterDialog, ImagePreview}
})
export default class ImagePresentation extends BasicComponent {

  loading: boolean = false;
  displayImages: number = 8;

  select() {
    this.setStep(3);
  }

  back() {
    this.setStep(1);
  }

  hasPreviousPreview(index) {
    return this.imageSelection.images[index - 1] != undefined;
  }

  hasNextPreview(index) {
    return this.imageSelection.images[index + 1] != undefined;
  }

  openPreview(index) {
    const preview = this.$refs[`preview-${index}`] as ImagePreview;
    preview.openDialog();
  }

  get active() {
    return Number(this.$store.getters.step) === 2;
  }

  get imageSelection(): ImageCollectionDto {
    if (!this.$store.getters.imageSelection) return {images: [], persons: []};
    return this.$store.getters.imageSelection;
  }

  get selection() {
    return this.$store.getters.image;
  }

  set selection(image) {
    this.$store.commit("setImage", image);
  }

  get imagePreviewText() {
    return this.$t("IMAGE_PREVIEW_TEXT").toString();//.replace("{expiryDate}", this.imageSelection.expiryDate)
  }

  get window(): Window {
    return window;
  }

  getImageHeight(): number {
    return 192;
  }

  getImageWidth(image: ImageDto): number {
    return image.orientation === ImageOrientationDto.LANDSCAPE ? 282 : 137;
  }

  getImageUrl(image) {
    return image;
  }

  getNextPreview(index) {
    return this.$refs[`preview-${index + 1}`];
  }

}
